import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useLocation } from 'react-router';
import FeedbackButton from './feedbackButton';
import FeedbackHeading from './feedbackHeading';

const FeedbackComponent = () => {
  const config = useApi(configApiRef);

  const gaCookie = Cookies.get('_ga');
  const now_micros: number = Date.now() * 1000;
  const [isGoodClicked, setGoodClicked] = useState(false);
  const [isBadClicked, setBadClicked] = useState(false);
  const currPagePath = useLocation().pathname;

  const getEnv = () => {
    const currURL = window.location.origin;

    if (
      currURL.indexOf('staging.') < 0 &&
      currURL.indexOf('dev.') < 0 &&
      currURL.indexOf('localhost') < 0
    ) {
      return 'prod';
    } else if (currURL.indexOf('staging.') > 0) {
      return 'staging';
    } else if (currURL.indexOf('dev.') > 0) {
      return 'dev';
    }
    // else
    return 'local';
  };

  const getMeasurementId = () => {
    const currEnv = getEnv();
    if (currEnv === 'prod') return 'G-8RN5ZH5R27';
    else if (currEnv === 'staging') return 'G-3Z0ZWKZWE9';
    else if (currEnv === 'dev') return 'G-972C7J1G7P';
    else if (currEnv === 'local') return 'G-3Z0ZWKZWE9';
    // else
    return '';
  };

  const apiKey = `${config.getOptionalString('feedbackAddon.gaApiKey')}`;

  if (apiKey === 'undefined' || apiKey.length === 0) {
    // if apiKey is not found in config, do not display feedback widget
    return null;
  }

  const sendEvent = (fbVal: String) => {
    const gaEndpoint = 'https://www.google-analytics.com/mp/collect?';
    const gaMeasurementId = `&measurement_id=${getMeasurementId()}`;

    const gaApiSecret = `&api_secret=${apiKey}`;
    const gaUrl = gaEndpoint + gaMeasurementId + gaApiSecret;

    let fbValInt = 1;
    if (fbVal === 'bad') {
      fbValInt = 0;
    }

    const feedbackJsonData = {
      client_id: gaCookie,
      timestamp_micros: now_micros,
      non_personalized_ads: false,
      events: [
        {
          name: 'feedback',
          params: {
            fb_value: fbValInt,
            path_name: currPagePath,
          },
        },
      ],
    };

    // Send data to the backend
    // ref: https://ga-dev-tools.google/ga4/event-builder/
    axios.post(gaUrl, JSON.stringify(feedbackJsonData));
  };

  const handleClickGood = () => {
    setGoodClicked(true);
    setBadClicked(false);
    sendEvent('good');
  };

  const handleClickBad = () => {
    setBadClicked(true);
    setGoodClicked(false);
    sendEvent('bad');
  };

  if (currPagePath.indexOf('component/principal-engineering-handbook') < 0) {
    return null;
  }

  return (
    <Grid container style={{ width: 220, justifyContent: 'center' }}>
      <div>
        <Grid container style={{ padding: 35 }} spacing={3} direction="column">
          <Grid item>
            <FeedbackHeading />
          </Grid>
          <Grid container direction="row" justifyContent="center">
            <Grid item>
              <FeedbackButton
                isGood
                isClicked={isGoodClicked}
                onClick={handleClickGood}
              />
            </Grid>
            <Grid item>
              <FeedbackButton
                isGood={false}
                isClicked={isBadClicked}
                onClick={handleClickBad}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};

export { FeedbackComponent };
